import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import gmailicon from "../ulits/images/mail-icon.svg";
import callicon from "../ulits/images/call-icon.svg";
import arrowwhite from "../ulits/images/arrow_icon.svg";
import { configs } from "../config";

function Header(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState({});

  useEffect(() => {
    setConfig(props?.configData);
  }, [props?.configData]);

  const ToggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const handleScrollToSection = () => {
    const section = document.getElementById("sell-your-car-section");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };


  return (
    <div className="site-header">
      {config && Object.keys(config).length > 0 && (
        <>
          <div className="header-top">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 col-10">
                  <div className="header-top-left">
                    <Link to="/" >
                      <img
                        src={`${configs.localApiUrl}${config?.Header_logo}`}
                        alt="header-logo"
                      />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 col-2">
                  <div className="header-top-right">
                    <ul>
                      <li>
                        <div className="sell_your_car">
                          <button
                            onClick={handleScrollToSection}>
                            Sell Your Car
                          </button>
                        </div>
                      </li>
                      <li>
                        {/* <a
                          href={`https://mail.google.com/mail/u/0/?view=cm&fs=1&to=${config?.Support_Email}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={gmailicon} alt="Email Support" />
                        </a> */}

                        <Link to={`mailto:${config && config?.Support_Email}`}>
                          <img src={gmailicon} alt="" />
                        </Link>
                      </li>
                      <li className="call-icon">
                        <a href={`tel:${config?.Contact_Number}`}>
                          <img src={callicon} alt="Call" />
                          {config?.Contact_Number}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="sidebar">
                    <button
                      className={`menu-button ${isOpen == true ? "open" : ""}`}
                      onClick={ToggleSidebar}
                    >
                      <span></span>
                      <span></span>
                      <span></span>
                    </button>
                    <nav className={`menu ${isOpen == true ? "open" : ""}`}>
                      <div className="sd-header">
                        <div className="menu-close" onClick={ToggleSidebar}>
                          <img src={arrowwhite} alt="Close Menu" />
                        </div>
                      </div>
                      <div className="hide-desk">
                        <div className="meno-menu">
                          <div className="social-icon">
                            <ul className="list-unstyled">
                              <li>
                                <Link
                                  to={`mailto:${config && config.Support_Email
                                    }`}
                                >
                                  <img src={gmailicon} alt="" />
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to={`tel:${config && config?.Contact_Number}`}
                                >
                                  <img src={callicon} alt="" />
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Header;
